import type React from "react";
import {
  Box,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  SimpleGrid,
} from "@chakra-ui/react";

interface KPIProps {
  totalCorbans: number;
  totalConsultas: number;
  propostasPagas: number;
  consultasPorPropostas: number;
  valorLiberado: number;
}

const KpiBiSection: React.FC<KPIProps> = ({
  totalCorbans,
  totalConsultas,
  propostasPagas,
  consultasPorPropostas,
  valorLiberado,
}) => {
  const bgGradient = useColorModeValue(
    "linear(to-r, green.500, blue.500)",
    "linear(to-r, green.600, blue.700)"
  );

  return (
    <Box
      w="100%"
      bgGradient={bgGradient}
      p={5}
      borderRadius="xl"
      boxShadow="sm"
      color="white"
    >
      <SimpleGrid columns={{ base: 1, md: 10 }} spacing={5} textAlign="center">
        <Stat>
          <StatLabel fontWeight="bold">Nº Corbans</StatLabel>
          <StatNumber>{totalCorbans.toLocaleString()}</StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold">Total de Consultas</StatLabel>
          <StatNumber>{totalConsultas.toLocaleString()}</StatNumber>
        </Stat>

        <Stat>
          <StatLabel fontWeight="bold">Total Propostas Pagas</StatLabel>
          <StatNumber>{propostasPagas.toLocaleString()}</StatNumber>
        </Stat>

        <Stat>
          <StatLabel fontWeight="bold">Consultas por Fechamento</StatLabel>
          <StatNumber>{consultasPorPropostas.toFixed(2)}</StatNumber>
        </Stat>

        <Stat>
          <StatLabel fontWeight="bold">Valor Liberado</StatLabel>
          <StatNumber>
            R${" "}
            {valorLiberado.toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold">Custo Total com Consultas</StatLabel>
          <StatNumber>
            R${" "}
            {(totalConsultas * 0.2).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold"> R$ Por Consulta</StatLabel>
          <StatNumber>R$0,20</StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold">Ticket Médio</StatLabel>
          <StatNumber>
            R${" "}
            {(propostasPagas > 0
              ? valorLiberado / propostasPagas
              : 0
            ).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold">VL por Consulta</StatLabel>
          <StatNumber>
            R${" "}
            {(totalConsultas * 0.2 > 0
              ? valorLiberado / (totalConsultas * 0.2)
              : 0
            ).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </StatNumber>
        </Stat>
        <Stat>
          <StatLabel fontWeight="bold">VL por NºConsulta</StatLabel>
          <StatNumber>
            R${" "}
            {(totalConsultas * 0.2 > 0
              ? valorLiberado / totalConsultas
              : 0
            ).toLocaleString("pt-BR", {
              minimumFractionDigits: 2,
            })}
          </StatNumber>
        </Stat>
      </SimpleGrid>
    </Box>
  );
};

export default KpiBiSection;
